module.exports = __webpack_public_path__ + "img/bumu2.cf378f54.jpg";